import { render, staticRenderFns } from "./AddEditLoanManagement.vue?vue&type=template&id=20e042bc&scoped=true"
import script from "./AddEditLoanManagement.vue?vue&type=script&lang=js"
export * from "./AddEditLoanManagement.vue?vue&type=script&lang=js"
import style0 from "./AddEditLoanManagement.vue?vue&type=style&index=0&id=20e042bc&prod&scoped=true&lang=css"
import style1 from "./AddEditLoanManagement.vue?vue&type=style&index=1&id=20e042bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e042bc",
  null
  
)

export default component.exports